export default function (editor, opts = {}) {
  const { labelTable, labelCMSCategory } = opts;
  const bm = editor.BlockManager;

  bm.add('child-data-list', {
    label: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50"><path d="M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg><div class="gjs-block-label">${labelTable}</div>`,
    category: labelCMSCategory,
    content: `
    <div data-gjs="child-data-list" data-gjs-type="child-data-list">
        <span class="badge badge-secondary">Child Data List</span>
    </div>
    `,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="false">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${labelTable}?"></i>
      </a>
    </span>
  `,
  });
}
